function Contact({ value, handleValue }) {
   return (
      <div className="group">
         <label htmlFor="contact">Contact</label>
         <input
            type="text"
            id="contact"
            required
            autoComplete="off"
            placeholder="+63 912 345 6789"
            value={value}
            onChange={e => handleValue(e.target.value, 'contact')}
         />
      </div>
   )
}

export default Contact
